import { FURNITURE_CONFIG } from '~/components/ThreeDModel/furnitureConfig'

const { panelThickness } = FURNITURE_CONFIG

export const WORK_TABLE_GEOMETRY = {
  topPanelYInset: 6,
  topPanelDepthInset: 0.2,
  backPanelHeight: 30,
  frontPanelHeight: 15,
  frontPanelGap: 0.5,
  bottomPanelWidth: 30,
  drawerHeight: 15,
  drawerGap: 0.3,
} as const

export function workTableInnerWidth(width: number): number {
  return width - 2 * panelThickness
}

export function workTableTopPanelSheet(
  innerWidth: number,
  depth: number
): { width: number; height: number } {
  return {
    width: innerWidth,
    height: depth - 3 * panelThickness - WORK_TABLE_GEOMETRY.topPanelDepthInset,
  }
}

export function workTableBackPanelSheet(innerWidth: number): {
  width: number
  height: number
} {
  return { width: innerWidth, height: WORK_TABLE_GEOMETRY.backPanelHeight }
}

export function workTableFrontPanelSheet(innerWidth: number): {
  width: number
  height: number
} {
  return {
    width: innerWidth - WORK_TABLE_GEOMETRY.frontPanelGap,
    height: WORK_TABLE_GEOMETRY.frontPanelHeight,
  }
}

export function workTableBottomPanelSheet(depth: number): {
  width: number
  height: number
} {
  return {
    width: WORK_TABLE_GEOMETRY.bottomPanelWidth,
    height: depth - panelThickness,
  }
}

export function workTableDrawerDimensions(
  innerWidth: number,
  depth: number,
  drawerCount: number
): { drawerWidth: number; drawerHeight: number; drawerDepth: number } {
  const slotSize = innerWidth / drawerCount
  return {
    drawerWidth: slotSize - WORK_TABLE_GEOMETRY.drawerGap,
    drawerHeight: WORK_TABLE_GEOMETRY.drawerHeight,
    drawerDepth: depth - panelThickness,
  }
}
